import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-rotary-selector[itemWidth]',
  templateUrl: './rotary-selector.component.html',
  styleUrls: ['./rotary-selector.component.scss'],
})
export class RotarySelectorComponent implements AfterViewInit {
  ArrowInterval: any;
  @ViewChild('items') _slider!: ElementRef;
  @Output() selected = new EventEmitter<number>();
  @Input() itemWidth!: number;
  @Input() set items(val: any[]) {}
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.computeWidth();
  }

  @HostListener('document:keydown.ArrowLeft', ['$event']) onArrowLeftHandler(
    event: KeyboardEvent
  ) {
    this.KBBack();
  }
  @HostListener('document:keydown.ArrowRight', ['$event']) onArrowRightHandler(
    event: KeyboardEvent
  ) {
    this.KBForward();
  }

  @HostListener('document:keyup.ArrowRight', ['$event']) onKeyUpRight(
    event: KeyboardEvent
  ) {
    this.KBup();
  }

  @HostListener('document:keyup.ArrowLeft', ['$event']) onKeyUpLeft(
    event: KeyboardEvent
  ) {
    this.KBup();
  }

  snap = true;
  moved = false;
  startX = 0;
  scrollLeft = 0;
  mouseDown = false;
  initialItems: Element[] = [];
  width = '';
  totalLength = 0;
  selectedItem!: number;
  allowedWindowItems!: number;
  windowSize!: number;
  counter = 0;
  get slider(): HTMLElement {
    return this._slider.nativeElement;
  }

  computeWidth() {
    let realWidth = Math.min(300, window.innerWidth);
    this.allowedWindowItems = Math.ceil(realWidth / this.itemWidth);
    this.allowedWindowItems =
      this.allowedWindowItems - (this.allowedWindowItems & 1 ? 0 : 1);
    this.windowSize = this.allowedWindowItems * this.itemWidth;
    setTimeout(() => {
      this.width = this.allowedWindowItems * this.itemWidth + 'px';
      this.detectSelected();
    }, 0);
  }

  detectSelected() {
    setTimeout(() => {
      let selectedOffset =
        Math.round(this.slider.scrollLeft / this.itemWidth) +
        (this.allowedWindowItems & 1 ? 0 : 1) +
        Math.round(this.allowedWindowItems / 2);

      for (let i = 0; i < this.slider.children.length; i++) {
        let child = this.slider.children[i];
        if (selectedOffset == i + 1) {
          child.classList.add('selected');
        } else child.classList.remove('selected');
      }

      this.selectedItem =
        selectedOffset % this.initialItems.length || this.initialItems.length;

      this.selected.emit(this.selectedItem);
    }, 100);
  }

  ngAfterViewInit(): void {
    this.startLogic();
    this.initMouseListeners();
    this.initTouchListeners();
  }

  startLogic() {
    let len = this.slider.children.length;
    if (len) {
      this.initialItems = Array.from(this.slider.children);
      setTimeout(() => {
        this.totalLength = this.slider.children.length * this.itemWidth;
        this.detectSelected();
      }, 0);
      this.computeWidth();
      this.initLoad();
      this.initLoad();
    } else setTimeout(this.startLogic.bind(this), 500);
  }

  initLoad() {
    let els = [...this.initialItems].reverse();
    els.forEach((element) => {
      let clone = element.cloneNode(true);
      this.slider.prepend(clone);
    });
    this.initialItems.forEach((element) => {
      let clone = element.cloneNode(true);
      this.slider.append(clone);
    });
  }

  addToStart() {
    if (!this.mouseDown) return;
    if (this.snap) this.slider.classList.remove('snap-inline');
    let els = [...this.initialItems].reverse();
    els.forEach((element) => {
      let clone = element.cloneNode(true);
      this.slider.prepend(clone);
      let toBeRemoved = this.slider.children[this.slider.children.length - 1];
      toBeRemoved.remove();
    });
    this.scrollLeft += this.itemWidth * this.initialItems.length;
    this.slider.scrollLeft = this.scrollLeft;
  }

  addToEnd() {
    if (!this.mouseDown) return;
    this.initialItems.forEach((element) => {
      let clone = element.cloneNode(true);
      this.slider.append(clone);
      let toBeRemoved = this.slider.children[0];
      toBeRemoved.remove();
    });
    this.scrollLeft -= this.itemWidth * this.initialItems.length;
  }

  addToStartKB() {
    if (this.snap) this.slider.classList.remove('snap-inline');
    let els = [...this.initialItems].reverse();
    els.forEach((element) => {
      let clone = element.cloneNode(true);
      this.slider.prepend(clone);
      let toBeRemoved = this.slider.children[this.slider.children.length - 1];
      toBeRemoved.remove();
    });
    this.scrollLeft += this.itemWidth * this.initialItems.length;
    this.slider.scrollLeft = this.scrollLeft;
  }

  addToEndKB() {
    this.initialItems.forEach((element) => {
      let clone = element.cloneNode(true);
      this.slider.append(clone);
      let toBeRemoved = this.slider.children[0];
      toBeRemoved.remove();
    });
    this.scrollLeft -= this.itemWidth * this.initialItems.length;
    this.slider.scrollLeft = this.scrollLeft;
  }

  initMouseListeners() {
    this.slider.addEventListener('mousedown', (event: any) => {
      this.mouseDown = true;
      this.slider.classList.add('active');
      if (this.snap) this.slider.classList.remove('snap-inline');
      this.startX = event.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
    });
    this.slider.addEventListener('mouseleave', () => {
      this.mouseDown = false;
      this.slider.classList.remove('active');
      if (this.snap) this.slider.classList.add('snap-inline');
    });
    this.slider.addEventListener('mouseup', () => {
      this.mouseDown = false;
      this.slider.classList.remove('active');
      if (this.snap) this.slider.classList.add('snap-inline');
    });
    this.slider.addEventListener('mousemove', (e: any) => {
      this.detectSelected();
      if (this.slider.scrollLeft < this.windowSize * 0.5) {
        this.addToStart();
      } else if (
        this.slider.scrollLeft + this.windowSize >
        this.totalLength * 0.8
      ) {
        this.addToEnd();
      }

      if (!this.mouseDown) return;
      this.moved = true;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - this.startX) * 1;
      this.slider.scrollLeft = this.scrollLeft - walk;
    });
  }

  initTouchListeners() {
    this.slider.addEventListener('touchstart', (event: any) => {
      this.mouseDown = true;
      this.slider.classList.add('active');
      if (this.snap) this.slider.classList.remove('snap-inline');
      this.startX = event.changedTouches[0].pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
    });
    this.slider.addEventListener('mouseleave', () => {
      this.mouseDown = false;
      this.slider.classList.remove('active');
      if (this.snap) this.slider.classList.add('snap-inline');
    });
    this.slider.addEventListener('touchend', () => {
      this.mouseDown = false;
      this.slider.classList.remove('active');
      if (this.snap) this.slider.classList.add('snap-inline');
    });
    this.slider.addEventListener('touchmove', (event: any) => {
      this.detectSelected();
      if (this.slider.scrollLeft < this.windowSize) {
        this.addToStart();
      } else if (
        this.slider.scrollLeft + this.windowSize >
        this.totalLength * 0.8
      ) {
        this.addToEnd();
      }
      this.moved = true;
      event.preventDefault();
      const x = event.changedTouches[0].pageX - this.slider.offsetLeft;
      const walk = (x - this.startX) * 1;
      this.slider.scrollLeft = this.scrollLeft - walk;
    });
  }

  private KBBack() {
    this.slider.classList.add('active');
    if (this.snap) this.slider.classList.remove('snap-inline');
    window.clearInterval(this.ArrowInterval);
    this.ArrowInterval = setInterval(() => {
      this.scrollLeft -= 2;
      this.slider.scrollLeft -= 2;
      this.detectSelected();
      if (this.slider.scrollLeft < this.windowSize) {
        this.addToStartKB();
      }
    }, 15);
  }

  private KBForward() {
    this.slider.classList.add('active');
    if (this.snap) this.slider.classList.remove('snap-inline');
    window.clearInterval(this.ArrowInterval);
    this.ArrowInterval = setInterval(() => {
      this.scrollLeft += 2;
      this.slider.scrollLeft += 2;
      this.detectSelected();
      if (
        this.slider.scrollLeft + this.windowSize >
        this.totalLength - this.windowSize
      ) {
        this.addToEndKB();
      }
    }, 15);
  }
  private KBup() {
    window.clearInterval(this.ArrowInterval);
    this.slider.classList.remove('active');
    if (this.snap) this.slider.classList.add('snap-inline');
  }
}

/**
 * let first = this.items.childNodes[0];

    let text = document.createElement('p');
    text.innerText = 'inserted';
    this.items.appendChild(text);
    this.items.append(this.items.childNodes[0].cloneNode(true));
    this.items.append(this.items.childNodes[0].cloneNode(true));
    this.items.append(this.items.childNodes[0].cloneNode(true));
    this.items.append(this.items.childNodes[0].cloneNode(true));
    first.parentNode?.insertBefore(
      this.items.childNodes[0].cloneNode(true),
      first
    );
    first.parentNode?.insertBefore(
      this.items.childNodes[0].cloneNode(true),
      first
    );
    first.parentNode?.insertBefore(
      this.items.childNodes[0].cloneNode(true),
      first
    );
 */
